import { FC } from 'react';
import { Menu } from '@mui/material';
import { useTheme } from '@monorepo/nova-ui';
import { ProgramList } from './components';
import { ProgramSelectorMenuProps } from './types';

/**
 * Main program selector menu component
 * Provides a clean, focused interface for program selection
 */
export const ProgramSelectorMenu: FC<ProgramSelectorMenuProps> = ({
  isOpen,
  anchorEl,
  onClose,
}) => {
  const theme = useTheme();

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          elevation: 8,
          sx: {
            mt: 1,
            minWidth: 200,
            width: {
              xs: 'auto',
              md: theme.spacing(115),
            },
            borderRadius: 2,
            backgroundColor: theme.palette.background.contrast,
            boxShadow: '0px 0px 8px 0px rgba(145, 120, 120, 0.15)',
          },
        },
      }}
      disableScrollLock
    >
      <div style={{ padding: '16px' }}>
        <ProgramList onClose={onClose} />
      </div>
    </Menu>
  );
};
